<template>
    <!--        Button Group -->
    <div class="col-12 d-flex flex-row justify-content-end">
        <div class="btn-group"
             role="group">
            <!--            Button Cancel-->
            <button
                :disabled="isLoading"
                class="btn btn-sm btn-danger"
                type="button"
                @click="$emit('cancel')">Abbrechen <i class="fas fa-times"></i></button>

            <!--            Button Save -->
            <button
                :disabled="isLoading"
                class="btn btn-sm btn-success"
                type="submit">Speichern <i v-if="!isLoading" class="fas fa-plus"></i><i
                v-if="isLoading" class="fas fa-spinner fa-spin"></i></button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'FormButtons',
    props: {
        isLoading: Boolean,
    },
};
</script>
